import { Image } from "antd";
import dayjs from "dayjs";
import React from "react";

export default function AvailableCard({ date, data, caddy_profile, onClick }) {
  return (
    <div
      onClick={() => (onClick ? onClick() : () => {})}
      style={{
        cursor: "pointer",
        padding: 15,
        boxShadow:
          "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
        display: "grid",
        gridTemplateColumns: "15% 50% 35%",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 20,
        marginTop: 20,
        fontSize: "clamp(12px, 3vw, 22px)",
      }}
    >
      <div
        style={{
          borderRadius: "50%",
          width: 50,
          height: 50,
          backgroundImage: `url(${caddy_profile.image_url})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        preview={false}
      />
      <center>
        <b>{dayjs(date).format("DD-MM-YYYY")}</b>
      </center>
      <div
        style={{
          whiteSpace: "nowrap",
          display: "flex",
          gap: 10,
          color: "#14AE5C",
          fontWeight: "bold",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div>{data.start}</div>
        {data.end && data.start !== data.end && (
          <>
            <div>-</div>
            <div>{data.end}</div>
          </>
        )}
      </div>
    </div>
  );
}
